import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../style/adminreport.css";

import { apiAxios } from "../../../utils/apiAxios";
import { OrderDropdownItem } from "./Interfaces/OrderDropdownItem";
import { ClinicDropdownItem } from "./Interfaces/ClinicDropdownItem";
import { OrderTypeDropdownItem } from "./Interfaces/OrderTypeDropdownItem";
import { MillingHubItem } from "./Interfaces/MillingHubItem";
import { DesignerItem } from "./Interfaces/DesignerItem";
import { DeliveryItem } from "./Interfaces/DeliveryItem";

import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyPDF from "../Admin/components/MyPDF";
const API_BASE = process.env.REACT_APP_API_BASE_URL;
interface OrderRow {
  orderId: number;
  clinic: string;
  type: string;
  assignedHub: string;
  assignedDesigner: string;
  partner: string;
  paymentType: string;
  paymentStatus: string;
  expectedDelivery: string;
  phone: string;
  payment: number;
  status: string;
}


const ManagerReport = () => {
  const [orderDropdown, setOrderDropdown] = useState<OrderDropdownItem[]>([]);
  const [clinicDropdown, setClinicDropdown] = useState<ClinicDropdownItem[]>([]);
  const [orderTypeDropdown, setOrderTypeDropdown] = useState<OrderTypeDropdownItem[]>([]);
  const [millingHubDropdown, setMillingHubDropdown] = useState<MillingHubItem[]>([]);
  const [designerDropdown, setDesignerDropdown] = useState<DesignerItem[]>([]);
  const [deliveryDropdown, setDeliveryDropdown] = useState<DeliveryItem[]>([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filters, setFilters] = useState({
    orderId: "",
    clinic: "",
    type: "",
    hub: "",
    designer: "",
    partner: "",
    paymentType: "",
    paymentStatus: "",
    fromDate: "",
    toDate: "",
  });

  const [data, setData] = useState<OrderRow[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFilters({
      orderId: "",
      clinic: "",
      type: "",
      hub: "",
      designer: "",
      partner: "",
      paymentType: "",
      paymentStatus: "",
      fromDate: "",
      toDate: "",
    });

    setSearch("");
    setStartDate(null);
    setEndDate(null);
    setData([]);
  };



  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: OrderRow) => row.orderId,
        sortable: true,
        width: "120px",
      },

      {
        name: "Clinic",
        selector: (row: OrderRow) => row.clinic,
        sortable: true,
        cell: (row: OrderRow) => (
          <div
            title={row.clinic}   // 👈 shows full text on hover
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px"
            }}
          >
            {row.clinic}
          </div>
        )
      },


      {
        name: "Type",
        cell: (row: OrderRow) => (
          <div
            title={row.type}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px"
            }}
          >
            {row.type}
          </div>
        )
      },

      {
        name: "Milling Hub",
        width: "130px",
        center: true,
        cell: (row: OrderRow) => (
          <div
            title={row.assignedHub}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "120px"
            }}
          >
            {row.assignedHub}
          </div>
        )
      },

      {
        name: "Designer",
        center: true,
        cell: (row: OrderRow) => (
          <div
            title={row.assignedDesigner}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px"
            }}
          >
            {row.assignedDesigner}
          </div>
        )
      },

      {
        name: "Partner",
        center: true,
        cell: (row: OrderRow) => (
          <div
            title={row.partner}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px"
            }}
          >
            {row.partner}
          </div>
        )
      },


      // {
      //   name: "Payment Type",
      //   width: "140px",
      //       center:true,
      //   selector: (row: OrderRow) => row.paymentType,
      // },

      {
        name: "Payment Status",
        width: "140px",
            center:true,
        cell: (row: OrderRow) => (
          <span className={` ${(row.paymentStatus || "").toLowerCase()}`}>
            {row.paymentStatus || "-"}
          </span>
        ),
      },

      // {
      //   name: "Delivery",
      //   selector: (row: OrderRow) => row.expectedDelivery,
      // },

      {
        name: "Payment",
        sortable: true,
        cell: (row: OrderRow) => (
          <span className="amount-pill">₹{row.payment}</span>
        ),
      },

    {
  name: "Status",
  
  cell: (row: OrderRow) => {
    const statusStyles: Record<string, { bg: string; color: string }> = {
      completed: { bg: "#d1fae5", color: "#065f46" }, 
       warranty_claimed: { bg: "#d1fae5", color: "#065f46" },            
      ready_for_delivery: { bg: "#dbeafe", color: "#1e40af" },    
      pending_acceptance: { bg: "#fef3c7", color: "#92400e" },     
      delay_report: { bg: "#fee2e2", color: "#991b1b" },          
      pending: { bg: "#f3f4f6", color: "#374151" },  
      cancelled: { bg: "#dc3545", color: "#fff" } ,
      cancellation_under_review: { bg: "#dc3545", color: "#fff" }         
    };
    const status = (row.status || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");

    const style = statusStyles[status] || {
      bg: "#f3f4f6",
      color: "#374151",
    };

    return (
      <span
        style={{
          backgroundColor: style.bg,
          color: style.color,
          padding: "5px 10px",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: 500,
          display: "inline-block",
          textTransform: "capitalize",
          whiteSpace: "nowrap",
          cursor:"pointer"
        }}
      >
        {row.status || "-"}
      </span>
    );
  },
  width: "190px",
}
    ],
    []
  );

  const exportExcel = () => {
    const exportData = data.map((d) => ({
      "Order ID": d.orderId,
      "Clinic": d.clinic,
      "Type": d.type,
      "Milling Hub": d.assignedHub,
      "Designer": d.assignedDesigner,
      "Partner": d.partner,
      // "Payment Type": d.paymentType,
      "Payment Status": d.paymentStatus,
      "Payment (₹)": d.payment,
      "Status": d.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Admin Report");

    XLSX.writeFile(workbook, "Manager_Report.xlsx");
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape");
    // Register font manually
  doc.setFontSize(16);

  doc.setTextColor(40);
const pageWidth = doc.internal.pageSize.getWidth();
doc.text("Manager Order Report", pageWidth / 2, 15, { align: "center" });
    const tableColumn = [
      "Order ID",
      "Clinic",
      "Type",
      "Hub",
      "Designer",
      "Partner",
     // "Payment Type",
      "Payment Status",
      "Payment",
      "Status",
    ];

    const tableRows = data.map((d) => [
      d.orderId,
      d.clinic,
      d.type,
      d.assignedHub,
      d.assignedDesigner,
      d.partner,
      // d.paymentType,
      d.paymentStatus,
      `Rs. ${d.payment}`,
      d.status,
    ]);

   autoTable(doc, {

    head: [tableColumn],

    body: tableRows,

    startY: 22,

    theme: "striped",

    styles: {
      fontSize: 9,
     cellPadding: 1,
      textColor: [60, 60, 60],
      valign: "middle",
    },

    headStyles: {
      fillColor: [31, 160, 133],
      textColor: [255, 255, 255],
      fontSize: 11,
      halign: "left",
    },

    bodyStyles: {
      textColor: [70, 70, 70],
       cellPadding: 0.8,
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },

    tableLineColor: [255, 255, 255],

    tableLineWidth: 0,

    margin: {
      left: 6,
      right: 6,
    },

    didDrawPage: () => {

      doc.setFontSize(9);

      doc.setTextColor(120);

      doc.text(
        `Generated on: ${new Date().toLocaleString()}`,
        14,
        doc.internal.pageSize.height - 10
      );
    },
  });

    // doc.text("Admin Order Report", 14, 15);

    doc.save("Manager_Report.pdf");
  };

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await apiAxios.post(`${API_BASE}/ManagerReport/get-report`, {
        orderID: filters.orderId || null,
        clinicID: filters.clinic ? Number(filters.clinic) : null,
        orderTypeID: filters.type ? Number(filters.type) : null,
        hubID: filters.hub ? Number(filters.hub) : null,
        designerID: filters.designer ? Number(filters.designer) : null,
        deliveryID: filters.partner ? Number(filters.partner) : null,
        paymentType: filters.paymentType || null,
        paymentStatus: filters.paymentStatus || null,
        fromDate: startDate,
        toDate: endDate,
        search: search || null
      });

      if (res.data?.isSuccess) {
        const mapped = res.data.data.map((x: any) => ({
          orderId: x.orderID,
          clinic: x.clinicName,
          type: x.orderTypeName || "N/A",
          assignedHub: x.hubName || "N/A",
          assignedDesigner: x.designerName || "N/A",
          partner: x.deliveryName || "N/A",
          paymentType: x.paymentType || "N/A",
          paymentStatus: x.paymentStatus || "N/A",
          expectedDelivery: x.createdDate,
          phone: x.mobileNo || "N/A",
          payment: x.paymentAmount || 0,
          status: x.currentOrderState || "N/A"
        }));

        setData(mapped);
      }



    } catch (err) {
      console.error("Report error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const [
        orderRes,
        clinicRes,
        typeRes,
        hubRes,
        designerRes,
        deliveryRes,
      ] = await Promise.all([
        apiAxios.get(`${API_BASE}/Manager/order-dropdown`),
        apiAxios.get(`${API_BASE}/Manager/clinic-dropdown`),
        apiAxios.get(`${API_BASE}/Manager/order-type-dropdown`),
        apiAxios.get(`${API_BASE}/Manager/milling-hub-dropdown`),
        apiAxios.get(`${API_BASE}/Manager/designer-dropdown`),
        apiAxios.get(`${API_BASE}/Manager/delivery-dropdown`),
      ]);

      if (orderRes.data?.isSuccess) setOrderDropdown(orderRes.data.data);
      if (clinicRes.data?.isSuccess) setClinicDropdown(clinicRes.data.data);
      if (typeRes.data?.isSuccess) setOrderTypeDropdown(typeRes.data.data);
      if (hubRes.data?.isSuccess) setMillingHubDropdown(hubRes.data.data);
      if (designerRes.data?.isSuccess) setDesignerDropdown(designerRes.data.data);
      if (deliveryRes.data?.isSuccess) setDeliveryDropdown(deliveryRes.data.data);

    } catch (err) {
      console.error("Dropdown error:", err);
    }
  };

  // const orderOptions = orderDropdown.map(item => ({
  //   value: item.orderID.toString(),
  //   label: `OrderID-${item.orderID}`
  // }));
    const orderOptions = useMemo(
  () =>
    [...(orderDropdown || [])]
      .sort(
        (a: any, b: any) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      )
      .map((item: any) => ({
        value: item.orderID.toString(),
        label: `${item.orderID} - ${new Date(item.createdDate).toLocaleDateString(
          "en-GB"
        )}`,
      })),
  [orderDropdown]
);

const clinicOptions = clinicDropdown.map(item => ({
    value: item.clinicID.toString(),
    label: item.clinicName
  }));

  const typeOptions = orderTypeDropdown.map(item => ({
    value: item.orderTypeID.toString(),
    label: item.orderTypeName
  }));

  const hubOptions = millingHubDropdown.map(item => ({
    value: item.userID.toString(),
    label: item.name
  }));

  const designerOptions = designerDropdown.map(item => ({
    value: item.userID.toString(),
    label: item.name
  }));

  const partnerOptions = deliveryDropdown.map(item => ({
    value: item.userID.toString(),
    label: item.name
  }));

  // const paymentTypeOptions = [
  //   { value: "Online", label: "Online" },
  //   { value: "COD", label: "COD" }
  // ];

  const paymentStatusOptions = [
    { value: "Paid", label: "Paid" },
    // { value: "Pending", label: "Pending" }
  ];
  const totalOrders = data.length;

  const totalRevenue = data.reduce((a, b) => a + (b.payment || 0), 0);

  const completedOrders = data.filter(
    (x) => (x.status || "").toLowerCase() === "completed"
  ).length;

  const pendingOrders = data.filter(
    (x) => (x.status || "").toLowerCase() !== "completed"
  ).length;

  const pdfDocument = useMemo(() => <MyPDF data={data} />, [data]);

  return (
    <div className="container-fluid ">
      {/* HEADER */}

      <div className="mb-5 report-design-heading ">
        <h4 className="mb-4">Manager Order Report</h4>
        <p className="text-muted mt-0 track-all-order">
          Track all orders and delivery status
        </p>
      </div>

      {/* SUMMARY CARDS */}


      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>

        </div>

        <div className="status-col">

           <h3>₹{totalRevenue.toFixed(2)}</h3>

          <div className="status-badge revenue-badge">
            <i className="bi bi-currency-rupee"></i>
            Total Revenue
          </div>
        </div>

        <div className="status-col">


          <h3>{completedOrders}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-check-circle-fill completed-icon"></i>
            Completed
          </div>
        </div>

        <div className="status-col">


          <h3>{pendingOrders}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Pending
          </div>
        </div>

      </div>
      {/* FILTER PANEL */}

      <div className="premium-card mt-2 p-3">

        {/* ROW 1 */}
        <div className="row g-3 mb-2">

          <div className="col-md-4">
            <Select
              options={orderOptions}
              value={orderOptions.find(o => o.value === filters.orderId) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, orderId: selected?.value || "" }))
              }
              placeholder="Select Order"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <Select
              options={clinicOptions}
              value={clinicOptions.find(o => o.value === filters.clinic) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, clinic: selected?.value || "" }))
              }
              placeholder="Select Clinic"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <Select
              options={typeOptions}
              value={typeOptions.find(o => o.value === filters.type) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, type: selected?.value || "" }))
              }
              placeholder="Order Type"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

        </div>

        {/* ROW 2 */}
        <div className="row g-3 mb-2">

          <div className="col-md-4">
            <Select
              options={hubOptions}
              value={hubOptions.find(o => o.value === filters.hub) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, hub: selected?.value || "" }))
              }
              placeholder="Milling Hub"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <Select
              options={designerOptions}
              value={designerOptions.find(o => o.value === filters.designer) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, designer: selected?.value || "" }))
              }
              placeholder="Designer"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <Select
              options={partnerOptions}
              value={partnerOptions.find(o => o.value === filters.partner) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, partner: selected?.value || "" }))
              }
              placeholder="Delivery User"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

        </div>

        {/* ROW 3 */}
        {/* <div className="row g-3 mb-2">

          <div className="col-md-4">
            <Select
              options={paymentTypeOptions}
              value={paymentTypeOptions.find(o => o.value === filters.paymentType) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, paymentType: selected?.value || "" }))
              }
              placeholder="Payment Type"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <Select
              options={paymentStatusOptions}
              value={paymentStatusOptions.find(o => o.value === filters.paymentStatus) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, paymentStatus: selected?.value || "" }))
              }
              placeholder="Payment Status"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-4">
            <input
              className="form-control"
              placeholder=" Global Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

        </div> */}

        {/* ROW 4 */}
        <div className="row g-3 align-items-end">

          <div className="col-md-4 position-relative">
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control pe-4"
              dateFormat="dd-MM-yyyy"
            />
            <i className="bi bi-calendar3 newicon"></i>
          </div>

          <div className="col-md-4 position-relative">
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control pe-4"
              dateFormat="dd-MM-yyyy"
            />
            <i className="bi bi-calendar3  newicon"></i>
          </div>

          <div className="col-md-4 d-flex align-items-center gap-3">

            <button
              className="btn btn-primary d-flex align-items-center px-4"
              onClick={loadReport}
            >

              Search
            </button>

            <button
              className="btn btn-secondary   d-flex align-items-center"
              onClick={handleClear}
            >

              Clear
            </button>

          </div>

        </div>

      </div>

      {/* EXPORT BUTTONS */}


      {/* TABLE */}

      <div className="premium-card mt-5">
      <div className="d-flex justify-content-end gap-2 mb-3">

  {/* Excel Button */}
  <button
    className="btn btn-success"
    onClick={exportExcel}
    disabled={data.length === 0}
  >
    <i className="bi bi-file-earmark-excel me-2"></i>
    Export Excel
  </button>

  {/* PDF Button */}
  <button
    className="btn btn-danger"
    onClick={exportPDF}
    disabled={data.length === 0}
  >
    <i className="bi bi-file-earmark-pdf me-2"></i>
    Download PDF
  </button>

</div>

        <DataTable
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          striped
          responsive
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />
      </div>
    </div>
  );
};

export default ManagerReport;